<template>
  <div class="secondary-card">
    <card-type :cardType="0" @changeOrderCardDetailClick="changeOrderCardDetailClick" @changeOrderCardTypeClick="changeOrderCardTypeClick" :cardList="cardList"></card-type>
    <cardDetailDialog :cardInfo="currentCardInfo" @changeDialogVisible="changeDialogVisible" :dialogVisible="dialogVisible"></cardDetailDialog>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref, watch } from 'vue'
import { useState } from '@/hooks'
import CardType from '../../../base-ui/card-type/card-type.vue'
import emitter from '@/utils/eventbus'
import cardDetailDialog from '../../../base-ui/card-detail-dialog/card-detail-dialog'
import { isNewUser } from '@/service/main/reserve'
import { useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'

export default defineComponent({
  props: {
    cardList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    CardType,
    cardDetailDialog

  },
  setup() {
    const route = useRoute()
    const dialogVisible = ref(false)
    const changeDialogVisible = (flag) => {
      dialogVisible.value = flag
    }

    const changeOrderCardTypeClick = async item => {
      // console.log(item);
      const res = await isNewUser(route.query.userId)
      // if (res.data == item.buyerRoleFlag) {
      //   emitter.emit('changeSecondaryCardClick', item)
      // } else {
      //   ElMessage({
      //     message: '该用户无购买权限!',
      //     type: 'warning',
      //   })
      // }
      item.isNew=res.data==1
      emitter.emit('changeSecondaryCardClick', item)
    }

    const changeOrderCardDetailClick = item => {
      // console.log(item);
      currentCardInfo.value = item
      dialogVisible.value = true
    }

    const currentCardInfo = ref({})


    return {
      currentCardInfo,
      changeDialogVisible,
      changeOrderCardDetailClick,
      changeOrderCardTypeClick,
      dialogVisible
    }

  }
})
</script>

<style scoped lang="less">
.secondary-card {
}
</style>
